import React, { useState } from "react";
import { Typography, Box, Card, Chip, Avatar, Link } from "@mui/material";
import { FaEdit, FaTrash, FaClock } from "react-icons/fa";
import { styled } from "@mui/system";
import { toggleEditModal, deleteTask } from "../../services/taskService";
import { toastAlert } from "../../helpers/toastAlert";
import ConfirmDeleteModal from "../CommonComponents/Confrimationmodal";
import { hasPermission } from "../../utils/commonutils";

const TaskCard = styled(Card)(({ theme }) => ({
  padding: "16px",
  marginBottom: "16px",
  cursor: "pointer",
  "&:hover": {
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
  },
}));

const taskDelete = async (task, thisEvt) => {
  try {
    let deleted = await deleteTask({ taskId: task._id }, thisEvt?.props);
    if (deleted?.message) {
      await thisEvt?.getTasks();
      toastAlert(deleted?.message ?? "Task Deleted Successfully.", "success");
    } else {
      toastAlert("Could not delete task.", "error");
    }
  } catch (error) {
    toastAlert("Please check Internet Connection.", "error");
  }
};

function Task({ provided, task, thisEvt, onClick }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleConfirmDelete = () => {
    setShowDeleteModal(false);
    taskDelete(task, thisEvt);
  };
  return (
    <>
      <TaskCard
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        onClick={onClick}
        sx={{
          display: "flex",
          flexDirection: "column",
          position: "relative",
          padding: "16px",
          borderRadius: "12px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          cursor: "pointer",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          border: "1px solid #e5e7eb",
          marginBottom: "12px",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
            borderColor: "#cbd5e1",
          },
        }}
      >
        {/* LEFT STATUS STRIPE */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: "4px",
            borderRadius: "12px 0 0 12px",
            background:
              task?.status === "newOrder"
                ? "#EF9C66"
                : task?.status === "design"
                  ? "#FCDC94"
                  : task?.status === "printing"
                    ? "#C8CFA0"
                    : "#78ABA8",
          }}
        />

        {/* HEADER */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Avatar sx={{ width: 36, height: 36, fontWeight: "bold" }}>
              {thisEvt?.state?.customerData
                ?.find((e) => e?._id === task?.customerId?._id)
                ?.companyName?.charAt(0)}
            </Avatar>

            <Box>
              <Typography variant="subtitle2" fontWeight={600}>
                {
                  thisEvt?.state?.customerData?.find(
                    (e) => e?._id === task?.customerId?._id,
                  )?.companyName
                } 
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {task?.employeeId?.name}
              </Typography>
            </Box>
          </Box>

          {/* PRIORITY CHIP */}
          <div>
            <Typography
              variant="caption"
              sx={{
                px: 2,
                py: 0.5,
                borderRadius: "50px",
                fontWeight: "600",
                fontSize: 11,
                textTransform: "capitalize",
                color:
                  task?.priority === "high"
                    ? "#991b1b"
                    : task?.priority === "medium"
                      ? "#92400e"
                      : "#1e40af",
                backgroundColor:
                  task?.priority === "high"
                    ? "#fee2e2"
                    : task?.priority === "medium"
                      ? "#fef3c7"
                      : "#dbeafe",
                border: `1px solid ${
                  task?.priority === "high"
                    ? "#fecaca"
                    : task?.priority === "medium"
                      ? "#fde68a"
                      : "#bfdbfe"
                }`,
                marginRight: "10px",
              }}
            >
              {task?.priority}
            </Typography>
          </div>
        </Box>

        {/* TASK NAME */}
        <Typography fontSize={13} fontWeight={500} mb={0.5}>
          {task?.name}
        </Typography>

        {/* DESCRIPTION */}
        <Typography variant="caption" color="text.secondary" mb={1}>
          {task?.description}
        </Typography>

        {/* FOOTER */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "12px",
          }}
        >
          {" "}
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <FaClock size={15} />
            <Typography variant="caption">{task?.deadline}</Typography>
          </Box>
          <Box
            sx={{ display: "flex", gap: 1 }}
            onClick={(e) => e.stopPropasgation()}
          >
            {hasPermission("update_task") && (
              <FaEdit
                style={{
                  cursor: "pointer",
                  color: "var(--thm-color)",
                  fontSize: 20,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleEditModal(thisEvt, task);
                }}
              />
            )}

            {hasPermission("delete_task") && (
              <FaTrash
                style={{ cursor: "pointer", color: "#d32f2f", fontSize: 18 }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDeleteModal(true);
                }}
              />
            )}
          </Box>
        </Box>
      </TaskCard>

      {/* DELETE CONFIRMATION MODAL */}
      <ConfirmDeleteModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        message="Are you sure you want to delete this Task?"
      />
    </>
  );
}

export default Task;
